import { convertEventSelectToTarget, FormFeedBack, Select } from '@repo/ui';
import { FormikValues } from 'formik';
import { Col, Label } from 'reactstrap';

interface Option {
  label: string;
  value: string | number;
}

interface PersonFormSelectProps {
  validation: FormikValues;
  name: string;
  label: string;
  options: Option[];
  isClearable?: boolean;
  placeholder?: string;
  md?: number;
}

export const PersonFormSelect = ({
  name,
  label,
  validation,
  options,
  isClearable = true,
  placeholder = 'Selecione',
  md = 4,
}: PersonFormSelectProps) => {
  const value = validation.values[name];
  const error = validation.errors[name];
  const touched = validation.touched[name];

  return (
    <Col md={md}>
      <Label htmlFor={name} className="form-label">
        {label}
      </Label>
      <Select
        id={name}
        name={name}
        value={value}
        options={options}
        placeholder={placeholder}
        isClearable={isClearable}
        onBlur={validation.handleBlur}
        onChange={(e) => {
          validation.handleChange(convertEventSelectToTarget(name, e));
        }}
        invalid={!!(touched && error)}
      />
      <FormFeedBack error={error} isInvalid={!!(touched && error)} />
    </Col>
  );
};
